// src/config.js
// Lee y parsea variables de entorno usadas por el front

export const SUPER_USERS = (() => {
  const raw = process.env.REACT_APP_SUPER_USERS || '';
  return raw
    .split(',')
    .map(s => s.trim())
    .filter(Boolean);
})();

export const FIREBASE_PROJECT_ID = process.env.REACT_APP_FIREBASE_PROJECT_ID || '';
export const FIREBASE_STORAGE_BUCKET = process.env.REACT_APP_FIREBASE_STORAGE_BUCKET || '';
// Añade aquí más exports si los necesitas